import React from 'react';
import { Table as AntTable, Space, Avatar, Popconfirm,Input ,Button, Image } from 'antd';
import { useState,useRef } from "react";
import { UserOutlined,SearchOutlined } from '@ant-design/icons';
import { genNumberTable } from '../../../../../function/genNumberTable';
import { useStateContext } from '../../../../../contexts/ContextProvider';
import { CUSTOMFIELD_TYPE_MAPPING } from '../../../../../data/constant';
import moment from 'moment';

const headerStyle = {
  color: '#525252',
};

const Table = ({ data, onEdit, onDelete, loading }) => {
  const { currentColor } = useStateContext();
  const [ setSearchText] = useState('');
  const [ setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
  });

  const columns = [
    { 
      title: 'ลำดับ',
      align: 'center',  
      width: 60, 
      dataIndex: 'number',
      key: 'number',
      onHeaderCell: () =>{return {style:headerStyle}}
    },
    { 
      title: 'Title', 
      align: 'center', 
      dataIndex: 'title', 
      key: 'title',
      onHeaderCell: () =>{return {style:headerStyle}} ,
      ...getColumnSearchProps('title'),
    },
    { 
      title: 'Type', 
      align: 'center', 
      dataIndex: 'type', 
      key: 'type',
      onHeaderCell: () =>{return {style:headerStyle}},
      render: (type) => CUSTOMFIELD_TYPE_MAPPING[type] || '-'
    },
    { 
      title: 'Example Image', 
      align: 'center', 
      dataIndex: 'example_image', 
      key: 'example_image',
      onHeaderCell: () =>{return {style:headerStyle}},
      render: (example_image) => example_image ? (
        <Image
          width={50}
          height={50}
          src={example_image}
          style={{ objectFit: 'cover' }}
          fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3Ik1RnG4W+FgYxN"
          preview={{
            src: example_image,
          }}
        />
      ) : '-'
    },
    { 
      title: 'Description', 
      align: 'center', 
      dataIndex: 'description', 
      key: 'description',
      onHeaderCell: () =>{return {style:headerStyle}},
      render: (description) => description ? (
        <div style={{ maxWidth: 200, wordBreak: 'break-word' }}>
          {description.length > 50 ? `${description.substring(0, 50)}...` : description}
        </div>
      ) : '-'
    },
    { 
      title: 'Created Date', 
      align: 'center', 
      dataIndex: 'create_date', 
      key: 'create_date',
      onHeaderCell: () =>{return {style:headerStyle}},
      render: (create_date) => create_date ? moment(create_date).format('DD/MM/YYYY HH:mm:ss') : '-'
    },
    {
      title: 'Created By',
      align: 'center',
      dataIndex: 'create_by',
      key: 'create_by',
      onHeaderCell: () =>{return {style:headerStyle}}
    },
    {
      title: 'การจัดการ',
      fixed: 'right',
      key: 'actions',
      align: 'center',
      render: (record) => (
        <Space size="middle">
          <div className="text-blue-500 cursor-pointer" onClick={() => onEdit(record)}>
            แก้ไข
          </div>
          <Popconfirm
            title="ลบข้อมูล"
            description="ยืนยันการลบข้อมูล ?"
            onConfirm={() => onDelete(record)}
            okText="ยืนยัน"
            cancelText="ยกเลิก"
            okButtonProps={{ style: { backgroundColor: currentColor, borderColor: currentColor } }}
          >
            <div className="text-red-500 cursor-pointer">ลบ</div>
          </Popconfirm>
        </Space>
      ),
      onHeaderCell: () => ({ style: headerStyle }),
    }
  ];

  return ( 
    <div className='overflow-x-auto'>
      <AntTable 
        loading={loading}   
        className='border-1 rounded-lg border-gray-200' 
        dataSource={genNumberTable(data)}
        columns={columns}  
        pagination={{ pageSize: 8 }} 
        rowKey={'id'}
        scroll={{ x: 'max-content' }}  
      />
    </div>
  );
};

export default Table;
